import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Editor } from 'slate-react';
import scrollIntoView from 'scroll-into-view';
import { PlusIcon, MoreIcon, InsertLeftIcon, InsertRightIcon, DeleteIcon } from '../../../components/Icons';
import PopoverOnClick from '../../../components/PopoverOnClick';
import TooltipOnHover from '../../../components/TooltipOnHover';
import Menu from '../../../components/Menu';
import TableIconWrapper from './TableIconWrapper';
var LEFT_ICON_WRAPPER = {
  right: "calc(100% - 10.5px)",
  bottom: 'calc(100% + 2px)'
};
var RIGHT_ICON_WRAPPER = {
  left: "calc(100% - 10.5px)",
  bottom: 'calc(100% + 2px)'
};

var TableColumnControl =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TableColumnControl, _PureComponent);

  function TableColumnControl(props) {
    var _this;

    _classCallCheck(this, TableColumnControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableColumnControl).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "scrollToColumn", function () {
      return scrollIntoView(_this.controlRef.current, {
        time: 300,
        align: {
          left: 1,
          leftOffset: -12
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectionChange", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          selectedColumnIndex = _ref.selectedColumnIndex;

      if (selectedColumnIndex === _this.props.columnIndex && !_this.state.showActions) {
        _this.setState({
          showActions: true
        });
      } else if (selectedColumnIndex !== _this.props.columnIndex && _this.state.showActions) {
        _this.setState({
          showActions: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickAddColumnBefore", function () {
      _this.props.editor.addTableColumn(_this.props.tableId, _this.props.columnIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickAddColumnAfter", function () {
      _this.props.editor.addTableColumn(_this.props.tableId, _this.props.columnIndex + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickRemoveColumn", function () {
      _this.props.editor.removeTableColumn(_this.props.tableId, _this.props.columnIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSelectColumn", function () {
      _this.props.editor.selectTableColumn(_this.props.tableId, _this.props.columnIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (position) {
      _this.props.editor.setHoveredColumn({
        index: _this.props.columnIndex + position,
        withDragLine: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnterLeftIcon", function () {
      return _this.onMouseEnter(-1);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnterRightIcon", function () {
      return _this.onMouseEnter(0);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.props.editor.setHoveredColumn(null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function (_ref2) {
      var closePopover = _ref2.closePopover;
      return React.createElement(Menu, {
        onRowClick: closePopover,
        className: "slite-design-system",
        style: {
          width: 158
        },
        items: _this.menuItems
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnterControls", function () {
      var _this$props = _this.props,
          editor = _this$props.editor,
          columnIndex = _this$props.columnIndex;
      editor.setHoveredColumnControls(columnIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeaveControls", function () {
      return _this.props.editor.setHoveredColumnControls(null);
    });

    _defineProperty(_assertThisInitialized(_this), "onIsOpenChange", function (_ref3) {
      var isOpen = _ref3.isOpen;
      isOpen && _this.onClickSelectColumn();

      _this.setState({
        menuOpened: isOpen
      });
    });

    _this.state = {
      showActions: false
    };
    _this.controlRef = React.createRef();
    _this.menuItems = [{
      key: 'insert-left',
      title: 'Insert left',
      icon: InsertLeftIcon,
      action: _this.onClickAddColumnBefore
    }, {
      key: 'insert-right',
      title: 'Insert right',
      icon: InsertRightIcon,
      action: _this.onClickAddColumnAfter
    }, {
      key: 'delete-column',
      title: 'Delete',
      icon: DeleteIcon,
      action: _this.onClickRemoveColumn
    }];
    return _this;
  }

  _createClass(TableColumnControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          store = _this$props2.store,
          tableId = _this$props2.tableId,
          editor = _this$props2.editor,
          columnIndex = _this$props2.columnIndex;
      this.onSelectionChange(store.getItem(tableId));
      store.subscribeToItem(tableId, this.onSelectionChange);
      var shouldScrollToIndex = editor.shouldScrollToIndex(tableId, columnIndex);

      if (shouldScrollToIndex) {
        editor.registerScroll(tableId, null);
        this.scrollToColumn();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.store.unsubscribeFromItem(this.props.tableId, this.onSelectionChange);
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this$props3 = this.props,
          editor = _this$props3.editor,
          tableId = _this$props3.tableId,
          isLastColumn = _this$props3.isLastColumn;
      var canAddColumn = editor.canAddTableColumn(tableId);
      return React.createElement(Fragment, null, canAddColumn && React.createElement(TableIconWrapper, {
        style: LEFT_ICON_WRAPPER,
        className: "left",
        onClick: this.onClickAddColumnBefore,
        tooltipContent: "Add column",
        tooltipPlacement: "top",
        onMouseEnter: this.onMouseEnterLeftIcon,
        onMouseLeave: this.onMouseLeave
      }, React.createElement(PlusIcon, {
        size: 12
      })), isLastColumn && canAddColumn && React.createElement(TableIconWrapper, {
        style: RIGHT_ICON_WRAPPER,
        className: "right",
        onClick: this.onClickAddColumnAfter,
        tooltipContent: "Add column",
        tooltipPlacement: "top",
        onMouseEnter: this.onMouseEnterRightIcon,
        onMouseLeave: this.onMouseLeave
      }, React.createElement(PlusIcon, {
        size: 12
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          isFirstColumn = _this$props4.isFirstColumn,
          isLastColumn = _this$props4.isLastColumn,
          isMobile = _this$props4.isMobile,
          isFocused = _this$props4.isFocused;
      var _this$state = this.state,
          showActions = _this$state.showActions,
          menuOpened = _this$state.menuOpened;
      return React.createElement("th", {
        className: classNames('slite-editor-table-column-control transition', {
          'is-selected': showActions,
          'menu-opened': menuOpened
        }),
        contentEditable: false,
        onMouseEnter: this.onMouseEnterControls,
        onMouseLeave: this.onMouseLeaveControls,
        ref: this.controlRef
      }, React.createElement("div", {
        className: "slite-editor-table-column-control-container"
      }, React.createElement("div", {
        className: classNames('slite-editor-table-controls position-relative transition', {
          'selection-in': isFocused
        })
      }, !isMobile && this.renderActions(), React.createElement("div", {
        className: classNames('slite-editor-table-control pointer background-shade-50 background-shade-40-on-hover transition', {
          'is-selected': showActions
        }),
        onClick: this.onClickSelectColumn
      }, !isMobile && (!showActions || isFirstColumn) && React.createElement("div", {
        className: "slite-editor-table-action-placeholder background-shade-45 left-placeholder"
      }), React.createElement(PopoverOnClick, {
        onIsOpenChange: this.onIsOpenChange,
        position: "bottom",
        content: this.renderMenu
      }, React.createElement("div", {
        className: "flexbox"
      }, React.createElement(TooltipOnHover, {
        id: "slite-editor-table-column-control",
        placement: "top",
        tooltipContent: "Options",
        disabled: isMobile
      }, React.createElement(MoreIcon, {
        className: "slite-editor-table-more-icon rotate-clockwise transition",
        size: 12
      })))), !isMobile && (!showActions || isLastColumn) && React.createElement("div", {
        className: "slite-editor-table-action-placeholder background-shade-45 right-placeholder"
      })))));
    }
  }]);

  return TableColumnControl;
}(PureComponent);

_defineProperty(TableColumnControl, "propTypes", {
  editor: PropTypes.instanceOf(Editor),
  store: PropTypes.shape({
    getItem: PropTypes.func,
    subscribeToItem: PropTypes.func,
    unsubscribeFromItem: PropTypes.func
  }),
  tableId: PropTypes.string,
  columnIndex: PropTypes.number,
  isFirstColumn: PropTypes.bool,
  isLastColumn: PropTypes.bool,
  isMobile: PropTypes.bool,
  isFocused: PropTypes.bool
});

export { TableColumnControl as default };